module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_cookie_policy", [["div",{"class":"site-page cookie"},[["section",{"class":"static-page-wrapper"},[["div",{"class":"title-block"},[["div",{"class":"page-width z6"},[["div",{"class":"title editor-wrapper","data-fox-alias":"CookieTitle","data-fox-context":"cookie"},[["p",{},[["textNode",{"text":"Cookie Use Policy"}]]]]]]]]],["section",{"class":"static-page-content"},[["div",{"class":"page-width static-page-docs"}]]]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/sitepage/cookie.tpl
// module id = 1089
// module chunks = 4